export const CLOUD_SERVICE_BASE_URL = "https://api.vibrant-wellness.com/v1";
export const CLOUD_SERVICE_BASE_URL_V2 = "https://api.vibrant-wellness.com/v2";
export const CURRENCY_MAP = {
    USD: "$",
    GBP: "£",
    EUR: "€",
    CHF: "CHF",
    DKK: "DKK",
    NOK: "NOK",
    SEK: "SEK",
    JPY: "¥",
    MXN: "$",
};

export const LANGUAGE_MAP = {
    en: "english",
    es: "spanish",
    fr: "french",
    it: "italian",
    de: "german",
    jp: "japanese",
  }